import { TourCompletionStatus } from 'onboarding-tours-client/constants';
export const isTourInProgress = tourCompletionStatus => {
  return tourCompletionStatus === TourCompletionStatus.INCOMPLETE;
};